<template>
  <div class="content">
    <b-breadcrumb>
      <b-breadcrumb-item :to="{ path: '/dashboard' }">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Editar Copias Certificadas</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="container">
      <div v-if="loading">
        <div id="loader">
          <font-awesome-icon icon="spinner" spin />
        </div>
      </div>
    </div>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog-route" hide-footer id="modal-confirm-dialog-route">
      <h4 class="text-center">¿Seguro que quiere salir de la página?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog-route')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="beforeLeave(true)">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
      <h4 class="text-center">¿Seguro que quiere salir sin guardar los cambios?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop id="modal-help-cotejos-2" size="xl" centered hide-footer>
      <div>
        <b-carousel id="carousel-cotejos-2" :interval="0" controls indicators background="#ababab">
          <b-carousel-slide :img-src="require('@/assets/img/cotejos/help/2_5.webp')"></b-carousel-slide>
        </b-carousel>
      </div>
    </b-modal>

    <b-modal
      id="confirmar-facturacion-modal-edit-cotejo"
      ref="confirmar-facturacion-modal-edit-cotejo"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <h4 class="text-center">¿Desea facturar su pago?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="confirmGenerarFactura(false)">No en este momento</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="confirmGenerarFactura(true)">Sí</b-button>
    </b-modal>

    <b-modal id="datos-fiscales-modal-edit-cotejo" no-close-on-backdrop centered hide-footer hide-header size="lg" @close.prevent>
      <FacturacionComponent
        :datosFacturacion="datosFacturacion"
        @closedFacturacionEvent="closedFacturacion"
        @canceledFacturacionEvent="closedFacturacion"
      />
    </b-modal>

    <div class="container-fluid">
      <b-row>
        <b-col class="col-3">
          <b-card>
            <TreeEditCotejo :cotejo="cotejo" :user="'Client'" :selected-component="currentComponentBody" @node="selected" />
          </b-card>
          <div>
            <b-img
              v-if="currentComponentBody === 'Solicitantes'"
              :src="require('@/assets/img/cotejos/help/1.webp')"
              fluid-grow
              alt="Descripción del solicitante"
            ></b-img>
            <b-img
              v-if="currentComponentBody === 'Documentos'"
              :src="require('@/assets/img/cotejos/help/6.webp')"
              fluid-grow
              alt="Descripción de la entrega de los documentos"
            ></b-img>
            <b-button
              v-if="currentComponentBody === 'Documentos'"
              class="orange-btn"
              block
              @click="$bvModal.show('modal-help-cotejos-2')"
            >
              Más información
            </b-button>
          </div>
        </b-col>
        <b-col class="col-9">
          <b-card>
            <b-row>
              <b-col class="col-12">
                <div v-if="currentComponentBody === 'Cargando'">
                  <LoadingData></LoadingData>
                </div>
                <div v-if="currentComponentBody === 'Pago'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form ref="pago" @submit.prevent="handleSubmit(pagoGeneradoHandler())">
                      <Pago
                        :cotejo="cotejo"
                        @submit.prevent
                        @allChecksPassed="submitForm('pago')"
                        @toggleOnLoadingEvent="toggleOnLoadingHandler"
                        @toggleOffLoadingEvent="toggleOffLoadingHandler"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'Solicitantes'">
                  <ComplementaSolicitante :cotejo="cotejo" @allChecksPassed="solicitanteCompletoHandler()" />
                </div>
                <div v-if="currentComponentBody === 'Documentos'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form
                      ref="documentos"
                      @submit.prevent="
                        handleSubmit(async () => {
                          await documentosCompletos();
                        })
                      "
                    >
                      <EntregaDocumentos
                        :cotejo="cotejo"
                        @submit.prevent
                        @toggleOnLoadingEvent="toggleOnLoadingHandler"
                        @toggleOffLoadingEvent="toggleOffLoadingHandler"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'Domicilio'">
                  <form ref="domicilio" @submit.prevent>
                    <Domicilio :cotejo="cotejo" @submit.prevent @allChecksPassed="domicilioCompleto" />
                  </form>
                </div>
                <div v-if="currentComponentBody === 'PagoComplementario'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form ref="pagocomplementario" @submit.prevent="handleSubmit()">
                      <PagoComplementario
                        :cotejo="cotejo"
                        @submit.prevent
                        @toggleOnLoadingEvent="toggleOnLoadingHandler"
                        @toggleOffLoadingEvent="toggleOffLoadingHandler"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'EsperaValidacion'">
                  <EsperaValidacion />
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import EsperaValidacion from "@/components/EsperaValidacion.vue";
import Domicilio from "@/views/clients/procesos/cotejo/Domicilio.vue";
import EntregaDocumentos from "@/views/clients/procesos/cotejo/EntregaDocumentos.vue";
import Pago from "@/views/clients/procesos/cotejo/Pago.vue";
import PagoComplementario from "@/views/clients/procesos/cotejo/PagoComplementario.vue";
import TreeEditCotejo from "@/views/clients/procesos/cotejo/TreeEditCotejo.vue";
import ComplementaSolicitante from "@/views/clients/procesos/cotejo/ComplementaSolicitante.vue";
import LoadingData from "@/components/LoadingData.vue";
import FacturacionComponent from '@/views/openpay/FacturacionComponent.vue';

import {
  CatDocumentosApi,
  ComparecientesApi,
  CotejosApi,
  CotizacionesApi,
  DocumentosApi,
  DocumentosXServiciosApi,
  DomiciliosApi,
  FacturasApi,
} from "@/api";
import loadingMixin from "@/mixins/loadingMixin";

export default {
  name: "EditCotejo",

  components: {
    TreeEditCotejo,
    Pago,
    EntregaDocumentos,
    PagoComplementario,
    Domicilio,
    EsperaValidacion,
    ComplementaSolicitante,
    LoadingData,
    FacturacionComponent
  },

  mixins: [loadingMixin],

  async created() {
    try {
      this.loading = true;
      this.cotejo.id = this.$route.params.id;

      await this.getCotejo();
      await this.getCotizacion();
      await this.addSolicitanteFromCompareciente();
      await this.addRepresentanteIfMoral();
      await this.loadDocumentos();
      await this.getDomicilio();
      await this.getCotizacionComplementaria();
      await this.getEstatus();
    } catch (error) {
      this.showErrorToast("Sucedió un error, intente más tarde");
      console.log(error);
    } finally {
      this.loading = false;
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.path.includes("editcomparecientes")) {
      next();
      return;
    }

    this.$refs["modal-confirm-dialog-route"].show();
    this.next = next;
  },

  data: () => ({
    next: null,
    prenode: null,

    currentComponentBody: "Cargando",

    cotejo: {
      id: null,
      folio: null,
      id_estatus: null,
      id_prioridad: null,
      id_cotizaciones: null,
      id_clientes: null,
      id_comparecientes: null,
      pago_complementario: null,
      id_cotizaciones_complementario: null,
      envio_domicilio: null,
      activo: null,
      creado: null,
      actualizado: null,
      domicilios_id: null,
      corredurias_id: null,
      validaSolicitantes: null,
      validaDomicilio: null,
      validaDocumentos: null,
      id_comparecientes_representante: null,
      referencia: null,
      solicitante: null,
      cotizacion: null,

      solicitantes: [],
      documentos: [],
      precio_total: null,
      domicilio: null,
      liga_pago_complementario: null,
      eligio_llevar_documentos: null,

      currentComponentValues: {
        Pago: false,
        Solicitantes: false,
        Documentos: false,
        Domicilio: false,
        PagoComplementario: false,
        Terminado: false,
        EsperaValidacion: false,
      },
    },

    catDocumentos: [],
    documentosXServicios: [],

    datosFacturacion: {
      cotizacionId: null,
      alreadyInvoiced: false,
    },
  }),

  methods: {
    beforeLeave(answer) {
      if (answer) {
        this.next();
      }
    },

    pagoGeneradoHandler() {
      this.cotejo.currentComponentValues.Pago = true;

      if (this.cotejo.envio_domicilio) {
        this.changeCurrentComponentBody("Domicilio");
        return;
      }

      this.changeCurrentComponentBody("Solicitantes");
    },

    solicitanteCompletoHandler() {
      this.changeCurrentComponentBody("Documentos");
    },

    selected(node) {
      const componentKeys = Object.keys(this.cotejo.currentComponentValues);
      const completionValues = Object.values(this.cotejo.currentComponentValues);

      const destIndex = componentKeys.findIndex((key) => key === node);
      const currentIndex = componentKeys.findIndex((key) => key === this.currentComponentBody);
      const pagoIndex = componentKeys.findIndex((key) => key === "Pago");
      const lastCompletedIndex = completionValues.lastIndexOf(true);

      if (destIndex === -1) return; // Invalid node

      if (destIndex > currentIndex) {
        this.handleForwardNavigation(node, destIndex, currentIndex, lastCompletedIndex);
      } else if (destIndex > pagoIndex) {
        this.currentComponentBody = node;
      }
    },

    handleForwardNavigation(node, destIndex, currentIndex, lastCompletedIndex) {
      // Check if destination is completed (green)
      if (this.cotejo.currentComponentValues[node]) {
        this.currentComponentBody = node;
        return;
      }

      // Destination is incomplete (yellow) - check if adjacent to last completed
      if (destIndex - lastCompletedIndex === 1) {
        this.currentComponentBody = node;
      } else {
        this.showIncompleteStepWarning();
      }
    },

    showIncompleteStepWarning() {
      this.$toast.warning("Completa la sección para poder continuar", {
        timeout: 3000,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    async getCotejo() {
      const result = await CotejosApi.detail(this.cotejo.id);

      this.cotejo = {
        ...this.cotejo,
        ...result,
      };
    },

    async getCotizacion() {
      const cotizacion = await CotizacionesApi.detail(this.cotejo.id_cotizaciones);

      this.cotejo.cotizacion = cotizacion;
      this.cotejo.precio_total = cotizacion.precio_total;
    },

    async addSolicitanteFromCompareciente() {
      const compareciente = await ComparecientesApi.detail(this.cotejo.id_comparecientes);
      this.cotejo.solicitantes.push(compareciente);
    },

    async addRepresentanteIfMoral() {
      if (this.cotejo.id_comparecientes_representante) {
        const representante = await ComparecientesApi.detail(this.cotejo.id_comparecientes_representante);
        this.cotejo.solicitantes.push(representante);
      }
    },

    async loadDocumentos() {
      try {
        await this.getCatDocumentosCotejos();
        await this.getDocumentosXServiciosCotejos();
        await this.getDocumentosCotejos();
        this.addTipoToDocumentos();
      } catch (error) {
        console.error("Error loading documentos:", error);
        throw error;
      }
    },

    async getCatDocumentosCotejos() {
      const { value } = await CatDocumentosApi.list({
        page: 0,
        registersPerPage: 0,
        categoria: "cotejos",
      });

      this.catDocumentos = value;
    },

    async getDocumentosXServiciosCotejos() {
      const { value } = await DocumentosXServiciosApi.list({
        page: 0,
        registersPerPage: 0,
        cat_servicios_id: 4,
        id_proceso: this.cotejo.id,
      });

      this.documentosXServicios = value;
    },

    async getDocumentosCotejos() {
      this.cotejo.documentos = await Promise.all(
        this.documentosXServicios.map((documentoXServicio) => DocumentosApi.detail(documentoXServicio.documentos_id)),
      );
    },

    addTipoToDocumentos() {
      this.cotejo.documentos.forEach((documento) => {
        documento.tipo = this.getCatDocumentoNombreById(documento.cat_documentos_id);
      });
    },

    getCatDocumentoNombreById(cat_documentos_id) {
      const catDocumento = this.catDocumentos.find((doc) => doc.id == cat_documentos_id);
      return catDocumento ? catDocumento.documento : null;
    },

    async getDomicilio() {
      this.cotejo.domicilio = await DomiciliosApi.detail(this.cotejo.domicilios_id);
    },

    async getCotizacionComplementaria() {
      if (this.cotejo.id_cotizaciones_complementario == null) {
        return;
      }

      const { liga_pago } = await CotizacionesApi.detail(this.cotejo.id_cotizaciones_complementario);
      this.cotejo.liga_pago_complementario = liga_pago;
    },

    async getEstatus() {
      const successfulPayment = this.$route.query.payment_status === "successful";
      if (this.cotejo.id_cotizaciones) {
        const result = await CotizacionesApi.verificarCotizacionPagada(this.cotejo.id_cotizaciones);

        if (!result.pagado) {
          this.currentComponentBody = "Pago";
          return;
        }

        if (successfulPayment) {
          if (this.cotejo.id_estatus === 14) {
            this.cotejo.id_estatus = 15;
            const updated = await CotejosApi.edit(this.cotejo.id, this.cotejo);
          }

          const response = await FacturasApi.getFacturaByCotizacionId(this.cotejo.id_cotizaciones);

          if (!response.facturaEncontrada) {
            this.$bvModal.show("confirmar-facturacion-modal-edit-cotejo");
            return;
          }
        }
      }

      this.currentComponentBody = "Solicitantes";

      const keys = Object.keys(this.cotejo.currentComponentValues);
      let currentIndex = keys.findIndex((value) => value === "Solicitantes");

      // if (this.cotejo.envio_domicilio && this.cotejo.id_estatus == 15) {
      //   this.currentComponentBody = "Domicilio";
      //   currentIndex = keys.findIndex((value) => value === "Domicilio");
      // }

      if (!this.cotejo.envio_domicilio && this.cotejo.id_estatus === 15) {
        this.currentComponentBody = "Solicitantes";
        currentIndex = keys.findIndex((value) => value === "Solicitantes");
      }

      if (this.cotejo.id_estatus === 44) {
        this.currentComponentBody = "Solicitantes";
        currentIndex = keys.findIndex((value) => value === "Solicitantes");
      }

      // if ([44, 16, 17].includes(this.cotejo.id_estatus)) {
      //   this.currentComponentBody = "EsperaValidacion";
      //   currentIndex = keys.findIndex(value => value === 'Documentos')
      // }

      // After staff revision
      if ([16, 17, 19, 20, 21, 74, 75, 76].includes(this.cotejo.id_estatus)) {
        this.currentComponentBody = "EsperaValidacion";
        currentIndex = keys.findIndex((value) => value === "PagoComplementario");
      }
      // if ([19, 20, 21, 74, 75, 76].includes(this.cotejo.id_estatus)) {
      if ([18].includes(this.cotejo.id_estatus)) {
        this.currentComponentBody = "PagoComplementario";
        currentIndex = keys.findIndex((value) => value === "Terminado");
      }

      for (let i = 0; i < currentIndex; i++) {
        this.cotejo.currentComponentValues[keys[i]] = true;
      }
    },

    changeCurrentComponentBody(body) {
      this.cotejo.currentComponentValues[this.currentComponentBody] = true;
      this.currentComponentBody = body;
    },

    submitForm(formToSubmit) {
      this.$refs[formToSubmit].dispatchEvent(new Event("submit"));
    },

    async domicilioCompleto() {
      this.loading = true;

      await this.actualizaDomicilio();
      this.cotejo.id_estatus = 44;
      await this.actualizaCotejo();

      this.changeCurrentComponentBody("Solicitantes");

      this.loading = false;
    },

    async documentosCompletos() {
      this.cotejo.id_estatus = 16;

      const result = await this.actualizaCotejo();

      if (!result) {
        return;
      }

      this.$toast.success("Información guardada.", {
        timeout: 4000,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });

      if (this.cotejo.envio_domicilio) {
        this.changeCurrentComponentBody("Domicilio");
      } else {
        this.changeCurrentComponentBody("EsperaValidacion");
      }
    },

    async actualizaDomicilio() {
      await DomiciliosApi.edit(this.cotejo.domicilios_id, {
        calle: this.cotejo.domicilio.calle,
        num_exterior: this.cotejo.domicilio.num_exterior,
        num_interior: this.cotejo.domicilio.num_interior,
        colonia: this.cotejo.domicilio.colonia,
        delegacion_municipio: this.cotejo.domicilio.delegacion_municipio,
        ciudad: this.cotejo.domicilio.ciudad,
        entidad: this.cotejo.domicilio.entidad,
        pais: this.cotejo.domicilio.pais,
        codigo_postal: this.cotejo.domicilio.codigo_postal,
        extranjero: 0,
        tipo: "Personal",
        tieneExtranjero: null,
        tieneTipo: null,
        lat: this.cotejo.domicilio.lat,
        lng: this.cotejo.domicilio.lng,
        valido: 1,
        comentario: null,
        validador: null,
      });
    },

    async actualizaCotejo() {
      try {
        this.loading = true;
        await CotejosApi.edit(this.cotejo.id, this.cotejo);
        return true;
      } catch (error) {
        console.log(error);
        this.showErrorToast("No se pudo actualizar la información. Intente más tarde.");
        return false;
      } finally {
        this.loading = false;
      }
    },

    confirmGenerarFactura(crearFactura) {
      this.$bvModal.hide("confirmar-facturacion-modal-edit-cotejo");

      if (!crearFactura) {
        this.closedFacturacion();
        return;
      }

      this.datosFacturacion.cotizacionId = this.cotejo.id_cotizaciones;
      this.$bvModal.show("datos-fiscales-modal-edit-cotejo");
    },

    closedFacturacion() {
      this.$bvModal.hide("confirmar-facturacion-modal-edit-cotejo");
      this.$bvModal.hide("datos-fiscales-modal-edit-cotejo");
      this.pagoGeneradoHandler();
    },
  },
};
</script>
